export default "__VITE_ASSET__d1fa0f87__"